module.exports = __webpack_public_path__ + "static/5-ff9fffe0efb569a8430e177ff42ef465.jpeg";